import dynamic from 'next/dynamic';

const DynamicHead = dynamic(() => import('@components/Head'), {
    ssr: true,
});
export default DynamicHead;
